
export const tipoAlergologica = (dataSemiologia) => {

  const preguntas = dataSemiologia?.preguntas;

  const causasList     = preguntas.causantes;
  const causasListText = causasList.map( causa => causa.text ).join(', ');
  const causasText     = causasList.length > 0 ? `por alergia causada por ${causasListText}` : '';

  const sintomasList     = preguntas.sintomas;
  const sintomasListText = sintomasList.map( sintoma => sintoma.text ).join(', ');
  const sintomasText     = sintomasList.length > 0 ? ` con sintomas ${sintomasListText}` : '';

  const comienzo      = (preguntas.comienzoTipo )
    ? ` desde hace ${preguntas.comienzoNumero ? `${preguntas.comienzoNumero}` : ''} ${preguntas.comienzoTipo?.text ? preguntas.comienzoTipo?.text : ''}`
    : '';

  const exposicionList     = dataSemiologia?.preguntas.exposicion;
  const exposicionListText = exposicionList.map( exposicion => exposicion.text ).join(', ');
  const exposicionText     = exposicionList.length > 0 ? ` con exposicion a ${exposicionListText}` : '';

  const observaciones = dataSemiologia?.preguntas.observaciones;
  const observacionesText = observaciones.active ? ` ${observaciones.text}` : '';

  return `${causasText}${sintomasText}${comienzo}${exposicionText}${observacionesText}`;
  
}